import { ref, computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { Apii } from '@/services/api.js';

const ApiService = new Apii();

// Module-level state — intentionally shared across all consumers
// so the parent step component and the banner sub-component coordinate
// (e.g. dismissing the banner hides the "Import from email" link in the
// parent header, and the parent's link opens the learn-more modal that
// lives inside the banner component).
const bannerDismissed = ref(false);
const showLearnMoreModal = ref(false);
const showUpgradeModal = ref(false);

const dismissEmailImportBanner = async () => {
    bannerDismissed.value = true;
    try {
        await ApiService.apiCall('/user/user-setting', 'put', {
            key: 'email_import_banner_dismissed',
            value: true,
        });
    } catch (error) {
        // Silently fail — banner stays hidden for this session
    }
};

export function useEmailImport() {
    const userData = computed(() => usePage().props.userData);
    const isSubscribed = computed(() => userData.value?.is_subscribed ?? false);
    const userEmail = computed(() => userData.value?.email || 'your email');

    const showEmailImportBanner = computed(
        () =>
            !bannerDismissed.value &&
            !userData.value?.email_import_banner_dismissed
    );

    return {
        isSubscribed,
        userEmail,
        showLearnMoreModal,
        showUpgradeModal,
        showEmailImportBanner,
        dismissEmailImportBanner,
    };
}
